import React, { useState } from 'react';

const FilteredList = ({ items }) => {
  const [filter, setFilter] = useState('');
  const filteredItems = items.filter(item =>
    item.toLowerCase().includes(filter.toLowerCase())
  );

  const handleFilterChange = event => {
    setFilter(event.target.value);
  };

  return (
    <div>
      <input
        type="text"
        placeholder="Filter items..."
        value={filter}
        onChange={handleFilterChange}
      />
      <ul>

        {filteredItems.map((item, index) => (<>
          <li key={index}>{item}</li>
         
        </>))}
      </ul>
    </div>
  );
};

const Filter = () => {
  const items = ['Apple', 'Banana', 'Cherry', 'Date', 'Elderberry'];

  return <FilteredList items={items} />;
};

export default Filter;
